import { FC } from 'react';
import { BackgroundColorWrapper, FormattingOptions, HorizontalPaddingWrapper, VerticalPaddingWrapper } from '../FormattingWrapper';
import MobileCarousel from './MobileCarousel';
import { getDefaultBackgroundColorName } from './TabbedStaticCarousel.utils';
import TabbedStaticCarouselUnpadded from './TabbedStaticCarouselUnpadded';

export type TabbedStaticCarouselProps = {
  title?: string;
  description?: string | React.ReactNode;
  showHeader?: boolean;
  isOnDark?: boolean
  slides: {
    title: string;
    description?: string;
    image: React.ReactNode;
    icon: React.ReactNode;
  }[];
  mobileSlides?: {
    image: React.ReactNode;
    title: string;
  }[];
  formattingOptions?: FormattingOptions;
}

/**
 * TabbedStaticCarousel, called "Tabbed Features" in Craft, displays a tabbed selection of features with a title and icon.
 * - The content is referred to an "Image" but can be any React node, including lottie animations which are frequently used.
 */

const TabbedStaticCarousel: FC<TabbedStaticCarouselProps> = ({ title, slides = [], showHeader, isOnDark = true, formattingOptions, mobileSlides }) => {
  // If backgroundColor is provided in formattingOptions, use it, otherwise use the default background colors based on isOnDark
  const backgroundColorName = formattingOptions?.backgroundColorName ?? getDefaultBackgroundColorName(isOnDark);

  return (
    // Using individual wrappers instead of FormattingWrapper to avoid applying horizontal padding to the mobile carousel
    <BackgroundColorWrapper backgroundColorName={backgroundColorName}>
      <VerticalPaddingWrapper paddingTop={formattingOptions?.paddingTop} paddingBottom={formattingOptions?.paddingBottom}>
        <HorizontalPaddingWrapper>
          <TabbedStaticCarouselUnpadded title={title} slides={slides} showHeader={showHeader} isOnDark={isOnDark} formattingOptions={formattingOptions} />
        </HorizontalPaddingWrapper>
        {/* We don't want horizontal padding for the mobile carousel, slides need to go to edge of screen */}
        <MobileCarousel slides={mobileSlides ?? slides} isOnDark={isOnDark} />
      </VerticalPaddingWrapper>
    </BackgroundColorWrapper>

  );
};

export default TabbedStaticCarousel;
